/* Keep */
export const CHANGE_SELECTED_SKU = 'CHANGE_SELECTED_SKU';
export const SET_CURRENCY_CONVERSION = 'SET_CURRENCY_CONVERSION';
export const SET_RECOMMENDATIONS = 'SET_RECOMMENDATIONS';
export const REQUEST_RECOMMENDATIONS = 'REQUEST_RECOMMENDATIONS';
